import React from 'react';
import { styled } from '@mui/material/styles';
//import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const PREFIX = 'ChartConfig';

const classes = {
    categories: `${PREFIX}-categories`,
    options: `${PREFIX}-options`,
    container: `${PREFIX}-container`,
    box: `${PREFIX}-box`,
    textOptions: `${PREFIX}-textOptions`,
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    filterTextPrimary: `${PREFIX}-filterTextPrimary`,
    filterTextSecondary: `${PREFIX}-filterTextSecondary`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.categories}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    [`& .${classes.options}`]: {
        flexWrap:'nowrap',
        alignItems: 'center',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    [`& .${classes.container}`]: {
        width:'900px'
    },

    [`& .${classes.box}`]: {
        margin: 0
    },

    [`& .${classes.textOptions}`]: {

    },

    [`& .${classes.formControl}`]: {
        minWidth: '100%',
    },

    [`& .${classes.selectEmpty}`]: {
        marginTop: theme.spacing(2),
    },

    [`& .${classes.filterTextPrimary}`]: {
        fontSize: theme.typography.pxToRem(14), /*adjust the fontsize of the dropdown menus of this component*/
        
    },

    [`& .${classes.filterTextSecondary}`]: {
        fontSize: theme.typography.pxToRem(13), /*aparantly not used*/
        
    }
}));



function ChartConfigButtons(props) {

    const {
        handleClickCategory,
        handleClickOption,
        chartConfig,
        parameters,
        selectedCategory,
        selectedOptions
    } = props;

    const buttonsCategories = [];
    const buttonGroupOptions = [];
    for (var i = 0; i < chartConfig.length; i++) {
        buttonsCategories.push(
            <Button key={i} variant={selectedCategory['category'] === chartConfig[i].id ? "contained" : "outlined"} onClick={handleClickCategory} value={chartConfig[i].id} disableElevation>{chartConfig[i].name}</Button>
        )
    }

    if (parameters !== null) {
        parameters.map((parameter) => {
            var title = parameter.name.charAt(0).toUpperCase() + parameter.name.slice(1) + ":";
            var options = parameter.options;
            const buttonOptions = [];
            options.map((option) => {
                buttonOptions.push(
                    <Button key={option.id} variant={selectedOptions.options[parameter.id] === option.id ? "contained" : "outlined"} onClick={handleClickOption} id={parameter.id} value={option.id} disableElevation>{option.name}</Button>
                );
            })
            buttonGroupOptions.push(
                    <Grid direction="row"  container sx={{flexWrap:'nowrap', alignItems: 'center'}} key={parameter.id}>
                        <Grid item style={{width: "225px"}} >
                            <Typography component={'div'} variant="body2" >
                                <Root style={{ display: 'flex' }}>
                                    <Box sx={{margin: 1}} m={1}>{title} </Box>
                                    <Box color="error.main"> *</Box>
                                </Root>
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <ButtonGroup sx={{ margin: 1}}  color="primary" aria-label="outlined primary button group">
                                {buttonOptions}
                            </ButtonGroup>
                        </Grid>
                    </Grid>
            );
        })
    }
    
    return (
        <div>
            <div>
                <Typography sx={{ margin: 1}} component={'div'} variant="body2">
                    <Box color="error.main">* Campos requeridos</Box>
                </Typography>
                <Typography sx={{ margin: 1}} component={'div'} variant="body2">
                    <div style={{ display: 'flex' }}>
                        <Box sx={{margin: 0}} m={1}>Seleccione tipo de gráfico: </Box><Box color="error.main"> *</Box>
                    </div>
                </Typography>
                <ButtonGroup sx={{ margin: 1}} color="primary" aria-label="outlined primary button group">
                    {buttonsCategories}
                </ButtonGroup>
            </div>
            {buttonGroupOptions}
        </div>
    );
}

function ChartConfigDropdown(props) {

    const {
        handleChangeCategory,
        handleChangeOption,
        chartConfig,
        parameters,
        selectedCategory,
        selectedOptions
    } = props;

    const menuCategories = [];
    const menuGroupOptions = [];
    for (var i = 0; i < chartConfig.length; i++) {
        menuCategories.push(
            <MenuItem key = {i} value={chartConfig[i].id}>
                <Typography className={classes.filterTextPrimary}>
                    {chartConfig[i].name}
                </Typography>
            </MenuItem>
        )
    }
    if (parameters !== null) {
        parameters.map((parameter) => {
            var title = parameter.name.charAt(0).toUpperCase() + parameter.name.slice(1) + ":";
            var options = parameter.options;
            const menuOptions = [];
            //console.log(parameter.id);
            options.map((option) => {
                menuOptions.push(
                    <MenuItem key = {option.id} value={JSON.stringify({optionId: option.id, parameterId: parameter.id})}>
                        <Typography className={classes.filterTextPrimary}>
                            {option.name}
                        </Typography>
                    </MenuItem>
                    );
            })
            menuGroupOptions.push(
                <div>
                    <Typography component={'div'} variant="body2">
                        <div style={{ display: 'flex' }}>
                            <Box className={classes.box} m={1}>{title} </Box><Box color="error.main"> *</Box>
                        </div>
                    </Typography>
                    <FormControl sx={{minWidth: '100%'}}>
                        <Select value={JSON.stringify({optionId: selectedOptions.options[parameter.id], parameterId: parameter.id})} onChange={handleChangeOption} displayEmpty className={classes.selectEmpty}>
                            <MenuItem key={'1'} value={''} disabled>
                                <Typography component={'div'} className={classes.filterTextPrimary}>
                                    {"Seleccione una opción"}
                                </Typography>
                            </MenuItem>
                            {menuOptions}
                        </Select>
                    </FormControl>
                </div>
            );
        })
    }

    return (
        <div>
            <div className={classes.categories}>
                <Typography component={'div'} variant="body2">
                        <Box color="error.main">* Campos requeridos</Box>
                </Typography>
                <Typography component={'div'} variant="body2">
                    <div style={{ display: 'flex' }}>
                        <Box className={classes.box} m={1}>Seleccione tipo de gráfico: </Box><Box color="error.main"> *</Box>
                    </div>
                </Typography>
                <FormControl sx={{minWidth: '100%'}}>
                    <Select value={selectedCategory['category']} onChange={handleChangeCategory} displayEmpty className={classes.selectEmpty}>
                        <MenuItem key={'-2'} value={null} disabled>
                            <Typography component={'div'} className={classes.filterTextPrimary}>
                                {"Seleccione un tipo"}
                            </Typography>
                        </MenuItem>
                        {menuCategories}
                    </Select>
                </FormControl>
                {menuGroupOptions}
            </div>
        </div>
    );
}

function ChartConfig(props) {
    const {
        handleClickCategory,
        handleChangeCategory,
        handleClickOption,
        handleChangeOption,
        chartConfig,
        parameters,
        selectedCategory,
        selectedOptions
    } = props;

    const theme = useTheme();
    const smCheck = useMediaQuery(theme.breakpoints.down('sm'));//screen is at most 600px wide
    return (
        <div>
            {smCheck ? 
                <ChartConfigDropdown 
                    handleChangeCategory={handleChangeCategory}
                    handleChangeOption={handleChangeOption}
                    chartConfig={chartConfig}
                    selectedCategory={selectedCategory}
                    selectedOptions={selectedOptions}
                    parameters={parameters}
                />
                :
                <ChartConfigButtons 
                    handleClickCategory={handleClickCategory}
                    handleClickOption={handleClickOption}
                    chartConfig={chartConfig}
                    selectedCategory={selectedCategory}
                    selectedOptions={selectedOptions}
                    parameters={parameters}
                />
            }
        </div>
    )
}

export default ChartConfig;